/* src/app/account/partials/accounts-form/accounts-form.component.scss */
/*# sourceMappingURL=accounts-form.component.css.map */
